export enum State {
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
}
